export default __webpack_public_path__ + "static/media/header-bg-img-covered.b7747b15.svg";